import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useAppDispatch, useAppSelector } from "../../../Hooks/useStore";
import { useCallback } from "react";
import { GetModelListDataTypes } from "../../../Schema/checkLogin.types";

export type AIModelsInitialStateTypes = {
  selectedModel: GetModelListDataTypes | null;
};

const initialState = {
  selectedModel: null,
} as AIModelsInitialStateTypes;

export const aiModels = createSlice({
  name: "aiModels",
  reducers: {
    setSelectedModel: (state, action: PayloadAction<GetModelListDataTypes>) => {
      state.selectedModel = action.payload;
    },
  },
  initialState,
});

export const { setSelectedModel } = aiModels.actions || {};

export default aiModels.reducer;

export const useAiModels = () => {
  const dispatch = useAppDispatch();
  const { selectedModel } = useAppSelector((state) => state.aiModels);

  const dispatchSetSelectedModel = useCallback(
    (data: GetModelListDataTypes) => {
      dispatch(setSelectedModel(data));
    },
    [dispatch],
  );

  return {
    selectedModel,
    dispatchSetSelectedModel,
  };
};
